// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 277 ? "c3be44fe" : chunkId) + "." + {"277":"17a7aa38f1479814","8788":"5ebab62231b7812a"}[chunkId] + ".js";
};